import * as React from "react";
import { useStaticQuery, graphql, navigate } from "gatsby";
import Downshift from "downshift";
import { slugifyWithRegex } from "../utilities/utilities";

const Search = () => {
  const bookData = useStaticQuery(graphql`
    {
      allAirtable(filter: { data: { bookTitle: { ne: null } } }) {
        nodes {
          data {
            Topics__from_topic_tags_
            bookTitle
          }
        }
      }
    }
  `);
  let bookSet = new Set();
  let topicSet = new Set();
  bookData.allAirtable.nodes.forEach(book => {
    if (book.data.Topics__from_topic_tags_) {
      book.data.Topics__from_topic_tags_.forEach(topic => {
        topicSet.add(topic);
      });
    }
    bookSet.add(book.data.bookTitle);
  });

  let searchList = [];
  searchList.push(
    ...[...topicSet].map(topic => {
      return {
        searchString: topic,
        searchType: "topic",
        redirectUrl: `/topics/${slugifyWithRegex(topic)}`,
      };
    })
  );
  searchList.push(
    ...[...bookSet].map(book => {
      return {
        searchString: book,
        searchType: "book",
        redirectUrl: `/books/${slugifyWithRegex(book)}`,
      };
    })
  );

  return (
    <>
      <AutoComplete items={searchList} />
    </>
  );
};

const AutoComplete = ({ items, onChange }) => {
  return (
    <Downshift
      onChange={selection =>
        // Add google search event here
        {
          typeof window !== "undefined" &&
            window.gtag("event", "search", { event_label: "navigation" });
          selection ? navigate(selection.redirectUrl) : "";
        }
      }
      itemToString={item => (item ? String(item.searchString) : "")}
    >
      {({
        getInputProps,
        getItemProps,
        getLabelProps,
        getMenuProps,
        isOpen,
        inputValue,
        highlightedIndex,
        selectedItem,
        getRootProps,
      }) => (
        <div className="dropdown w-full">
          <input
            type="text"
            {...getInputProps({
              placeholder: "type a topic or book",
              className: "input input-bordered w-full bg-base-300",
            })}
          />
          {isOpen ? (
            <ul className="dropdown-content dropdown-open menu shadow bg-base-300 w-full rounded-box">
              {items
                .filter(
                  item =>
                    !inputValue ||
                    item.searchString
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                )
                .slice(0, 5)
                .map((item, index) => (
                  <li
                    {...getItemProps({
                      key: item.searchString,
                      index,
                      item,
                      className: `${
                        highlightedIndex === index ? "active" : ""
                      } ${
                        selectedItem === item ? "font-semibold" : ""
                      } text-left`,
                    })}
                  >
                    <span>{item.searchString}</span>
                  </li>
                ))}
            </ul>
          ) : (
            <></>
          )}
        </div>
      )}
    </Downshift>
  );
};

export default Search;
